import React, { Component } from "react";
import Helmet from "react-helmet";
import config from "../../utils/siteConfig";

import favicon152 from "../../../static/favicon-152.png"
import favicon144 from "../../../static/favicon-144.png"
import favicon96 from "../../../static/favicon-96.png"
import favicon72 from "../../../static/favicon-72.png"
import favicon57 from "../../../static/favicon-57.png"
import favicon from "../../../static/favicon.ico"
import safariPinnedTab from "../../../static/safari-pinned-tab.svg"

export default class Seo extends Component {
  render() {
    const { postNode, postPath, postSEO } = this.props;
    let title;
    let description;
    let image;
    let postURL;
    const realPrefix = config.pathPrefix === "/" ? "" : config.pathPrefix;
    if (postSEO) {
      const postMeta = postNode.frontmatter;
      title = postMeta.title;
      description = postNode.subTitle;
      image = postMeta.cover.childImageSharp.resize.src;
      postURL = config.siteUrl + realPrefix + postPath;
    } else {
      title = config.siteTitle;
      description = config.siteDescription;
      image = config.siteLogo;
    }
    image = config.siteUrl + realPrefix + image;
    const blogURL = config.siteUrl + config.pathPrefix;
    const schemaOrgJSONLD = [
      {
        "@context": "http://schema.org",
        "@type": "WebSite",
        url: blogURL,
        name: title,
        alternateName: config.siteLongTitle ? config.siteLongTitle : ""
      }
    ];
    if (postSEO) {
      schemaOrgJSONLD.push([
        {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              item: {
                "@id": postURL,
                name: title,
                image
              }
            }
          ]
        },
        {
          "@context": "http://schema.org",
          "@type": "BlogPosting",
          url: blogURL,
          name: title,
          alternateName: config.siteTitleAlt ? config.siteTitleAlt : "",
          headline: title,
          image: {
            "@type": "ImageObject",
            url: image
          },
          description
        }
      ]);
    }
    return (
      <Helmet>
        <meta name="description" content={description} />
        <meta name="image" content={image} />
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>
        <meta property="og:locale" content="de_DE" />
        <meta property="og:site_name" content={config.ogSiteName} />
        <meta property="og:url" content={postSEO ? postURL : blogURL} />
        {postSEO ? <meta property="og:type" content="article" /> : null}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta
          property="fb:app_id"
          content={config.siteFBAppID ? config.siteFBAppID : ""}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:creator"
          content={config.userTwitter ? config.userTwitter : ""}
        />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:url" content={config.siteUrl} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />

        <link rel="apple-touch-icon-precomposed" href={favicon152} />
        <link rel="icon" type="image/png" href={favicon152} sizes="152x152" />
        <meta name="msapplication-TileColor" content="#FFFFFF" />
        <meta name="msapplication-TileImage" content={favicon144} />
        <link rel="icon" type="image/png" href={favicon96} sizes="96x96" />
        <link rel="icon" type="image/png" href={favicon72} sizes="72x72" />
        <link rel="icon" type="image/png" href={favicon57} sizes="57x57" />
        <link rel="shortcut icon" href={favicon} />
        <link rel="mask-icon" href={safariPinnedTab} color="#19AD8E" />
        <meta name="theme-color" content="#ffffff" />
      </Helmet>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Other/Seo.jsx